// extracted by mini-css-extract-plugin
export default {"AppDate":"AppDate_AppDate__C-BGK"};